import React, { FC } from "react";
import classes from "../../styles/NewTable.module.css";

export interface TableHeadDataProps {
  id: number;
  title: string;
  value?: string; // optional for non-sortable columns
}

interface TableHeadProps {
  style?: React.CSSProperties;
   rowStyle?: React.CSSProperties;
  data: TableHeadDataProps[];
  onSort?: (key: string) => void;
  sortKey?: string;
  sortOrder?: "asc" | "desc";
}

const TableHead: FC<TableHeadProps> = ({
  data,
  style,
  rowStyle,
  onSort,
  sortKey,
  sortOrder,
}) => {
  return (
    <thead className={classes.table_head} style={style}>
      <tr style={rowStyle}>
        {data.map((head) => (
          <th
            key={head.id}
            onClick={
              head.value && onSort ? () => onSort(head.value!) : undefined
            }
            style={{ cursor: head.value && onSort ? "pointer" : "default" }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                justifyContent:
                  head.title === "Call Status" ? "center" : "flex-start",
              }}
            >
              {head.title}
              {head.value && onSort && (
                <div className={classes.sort_icon}>
                  <div 
                    className={`${classes.sort_arrow} ${classes.sort_arrow_up} ${sortKey === head.value && sortOrder === "asc" ? classes.sort_arrow_active : ""}`}
                  />
                  <div 
                    className={`${classes.sort_arrow} ${classes.sort_arrow_down} ${sortKey === head.value && sortOrder === "desc" ? classes.sort_arrow_active : ""}`}
                  />
                </div>
              )}
            </span>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
